import { render, staticRenderFns } from "./orderStats.vue?vue&type=template&id=1c152fc0&scoped=true"
import script from "./orderStats.vue?vue&type=script&lang=js"
export * from "./orderStats.vue?vue&type=script&lang=js"
import style0 from "./orderStats.vue?vue&type=style&index=0&id=1c152fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c152fc0",
  null
  
)

export default component.exports